/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum_Frame_GapInputs */



/**
* | output |
* | --- |
* | "Maximum Frame Gap" |
*
* @param {Maximum_Frame_GapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maximum_frame_gap = /** @type {((inputs?: Maximum_Frame_GapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum_Frame_GapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart d’images maximal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximaler Rahmenabstand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Distanza massima tra i fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальный разрыв между кадрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio máximo entre marcos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大帧间隙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大フレームギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम फ्रेम अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaço máximo entre quadros")
	return /** @type {LocalizedString} */ ("Maximum Frame Gap")
});